"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TldGridSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index2 = _interopRequireDefault(require("../../../elements/other/section-item/index.js"));
var _tldGridItem = _interopRequireDefault(require("./tld-grid-item"));
var _scrollIndicator = _interopRequireDefault(require("../../product-merchandising/plan-box-section-subscription/scroll-indicator"));
/* eslint-disable no-nested-ternary */

const TldGridWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TldGridWrapper",
  class: "pl-tolzsiy",
  vars: {
    "tolzsiy-0": [({
      childCount
    }) => `repeat(${childCount}, minmax(332px, 1fr))`],
    "tolzsiy-4": [({
      childCount
    }) => `repeat(${childCount % 3 === 0 ? 3 : 2}, minmax(332px, 1fr))`],
    "tolzsiy-6": [({
      childCount
    }) => `repeat(${childCount % 3 === 0 ? 3 : 4}, minmax(332px, 1fr))`]
  }
});

/**
 * Render TldColumnGrid Component
 *
 * @param {Object} props React props
 * @param {number} props.gridSize Number of items to display
 * @param {Array} [props.items] Array of TldColumnGridItems
 * @param {Object} props.adOverrides Ad Server Overrides
 * @returns {React.ReactElement} TldColumn element
 * @public
 */

// eslint-disable-next-line max-statements, complexity
function TldGrid({
  gridSize,
  items,
  children,
  adOverrides = {},
  sponsoredText,
  adText,
  scrollingElementRef,
  ...props
}) {
  // render nothing if children & items are empty
  if (!children?.length && !items?.length) {
    return null;
  }

  // For storefront, prefer children over all the item logic
  if (children?.length > 0) {
    const filteredChildren = children.filter((_child, index) => index < gridSize);
    return /*#__PURE__*/_react2.default.createElement(TldGridWrapper, (0, _extends2.default)({
      "data-cy": "tld-grid",
      childCount: filteredChildren.length,
      ref: scrollingElementRef
    }, props), filteredChildren);
  }
  const childCount = gridSize > items.length ? items.length : gridSize;
  const fixedItems = {};
  const defaultList = [];
  const tldItemGrid = items.reduce((prev, current, index) => {
    if (current.tld) {
      prev[current.tld] = current;
    }
    if (current.fixed) {
      fixedItems[index + 1] = current;
    } else {
      defaultList.push(current);
    }
    return prev;
  }, {});
  const overrideTlds = Object.values(adOverrides).map(({
    tld
  }) => tld);
  const renderItems = [];
  let i = 0;
  let position = 1;

  // set default value of sponsored to true for adOverrides
  Object.values(adOverrides).map(adOverride => adOverride.sponsored ??= true);
  const atLeastOneSponsored = Object.values(adOverrides).concat(items.slice(0, gridSize)).some(({
    sponsored
  }) => sponsored);
  while (renderItems.length < gridSize) {
    let item = defaultList[i];

    // prevent duplicates
    if (overrideTlds.includes(item?.tld)) {
      i++;
      item = defaultList[i];
    }
    const adOverride = adOverrides[position];
    if (adOverride) {
      const {
        clickUrl,
        impressionUrl,
        sponsored
      } = adOverride;
      if (adOverride.imageUrl) {
        item = {
          title: adOverride.title,
          imageUrl: adOverride.imageUrl,
          clickUrl,
          impressionUrl,
          sponsored: sponsored && adText
        };
      } else {
        const overrideItem = tldItemGrid[adOverride?.tld];
        if (overrideItem) {
          item = {
            ...overrideItem,
            impressionUrl,
            clickUrl,
            sponsored: sponsored && sponsoredText
          };
        } else {
          const fixed = fixedItems[position];
          if (fixed && !overrideTlds.includes(fixed?.tld)) {
            item = fixed;
          } else {
            i++;
          }
          if (item.sponsored) {
            item.sponsored = sponsoredText;
          } else if (atLeastOneSponsored) {
            item.sponsored = '';
          }
        }
      }
    } else {
      const fixed = fixedItems[position];
      if (fixed && !overrideTlds.includes(fixed?.tld)) {
        item = fixed;
      } else {
        i++;
      }
      if (item.sponsored) {
        item.sponsored = sponsoredText;
      } else if (atLeastOneSponsored) {
        item.sponsored = '';
      }
    }
    renderItems.push(/*#__PURE__*/_react2.default.createElement(_tldGridItem.default, {
      key: renderItems.length,
      item: item,
      position: position
    }));
    position++;
  }
  return /*#__PURE__*/_react2.default.createElement(TldGridWrapper, (0, _extends2.default)({
    "data-cy": "tld-grid",
    childCount: childCount,
    ref: scrollingElementRef
  }, props), renderItems);
}
TldGrid.propTypes = {
  _name: _propTypes.default.string,
  gridSize: _propTypes.default.number,
  sponsoredText: _propTypes.default.string,
  adText: _propTypes.default.string,
  children: _propTypes.default.arrayOf(_propTypes.default.node),
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_tldGridItem.default.propTypes)),
  adOverrides: _propTypes.default.objectOf(_propTypes.default.shape({
    clickUrl: _propTypes.default.string,
    impressionUrl: _propTypes.default.string,
    sponsored: _propTypes.default.string,
    ..._propTypes.default.oneOfType([_propTypes.default.shape({
      tld: _propTypes.default.string
    }), _propTypes.default.shape({
      imageUrl: _propTypes.default.string,
      title: _propTypes.default.string
    })])
  })),
  scrollingElementRef: _propTypes.default.any
};
const TldSectionWrapper = /*#__PURE__*/(0, _react.styled)(_section.default)({
  name: "TldSectionWrapper",
  class: "pl-t1iho4up"
});

/**
 * Render TldGridSection Component
 *
 * @param {Object} props React props
 * @param {Array} [props.items] Array of TldColumnGridItems
 * @param {String} props.verticalMargin Vertical margin spacing
 * @returns {React.ReactElement} TldGridSection element
 * @public
 */
function TldGridSection({
  id,
  _name,
  items = [],
  adOverrides = {},
  sponsoredText,
  adText,
  gridSize = 6,
  verticalMargin = 'none',
  children,
  ...headlineProps
}) {
  const scrollingElementRef = /*#__PURE__*/_react2.default.createRef();
  const parentName = 'tld-column';
  const {
    eyebrow,
    eyebrowTag = 'h2',
    headlineTag,
    ...headlineRest
  } = headlineProps;
  const itemCount = children?.length || items?.length;
  return /*#__PURE__*/_react2.default.createElement(TldSectionWrapper, (0, _extends2.default)({
    id: `tld-grid-section-${id}`,
    dataCy: `${parentName}-section`,
    verticalMargin: verticalMargin,
    showOverflow: true,
    padding: "small"
  }, _name && {
    ..._patternLibraryUtils.tracking.create(_name, false, true)
  }), (headlineProps?.eyebrow || headlineProps?.heading || headlineProps?.description) && /*#__PURE__*/_react2.default.createElement(_index2.default, {
    "data-cy": "content-item",
    rounded: false
  }, /*#__PURE__*/_react2.default.createElement(_index.default, (0, _extends2.default)({
    eyebrow: eyebrow,
    eyebrowTag: eyebrowTag,
    headlineTag: headlineTag || (eyebrow ? 'h3' : 'h2')
  }, headlineRest))), itemCount > 0 && /*#__PURE__*/_react2.default.createElement(TldGrid, {
    items: items,
    gridSize: gridSize,
    adOverrides: adOverrides,
    sponsoredText: sponsoredText,
    adText: adText,
    scrollingElementRef: scrollingElementRef
  }, children), itemCount > 1 && /*#__PURE__*/_react2.default.createElement(_scrollIndicator.default, {
    elementArr: itemCount,
    element: scrollingElementRef
  }));
}
TldGridSection.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_tldGridItem.default.propTypes)),
  adOverrides: _propTypes.default.objectOf(_propTypes.default.any),
  sponsoredText: _propTypes.default.string,
  adText: _propTypes.default.string,
  gridSize: _propTypes.default.number,
  children: _propTypes.default.arrayOf(_propTypes.default.node),
  ..._patternLibraryUtils.marginProps,
  ..._index.default.propTypes
};